import PropTypes from "prop-types"
import React from "react"
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'

const Header = ({ siteTitle }) => (
  <header
    style={{
      background: `#FF0000`,
      marginBottom: `1.45rem`,
    }}
  >
      <Navbar bg="light" expand="lg">
        <Navbar.Brand href="/">{ siteTitle } </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link href="/bestellen">Bestellen</Nav.Link>
            <Nav.Link href="/faq">FAQ</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
